import { render, staticRenderFns } from "./brick_1.vue?vue&type=template&id=2f1bcd49&scoped=true&"
import script from "./brick_1.vue?vue&type=script&lang=js&"
export * from "./brick_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1bcd49",
  null
  
)

export default component.exports